import AmazingScroll from './modules/amazingScroll.js';
import fixNav from './modules/fixNav.js';
import lineGrover from './modules/lineGrower.js';
import BlogSlider from './modules/BlogSlider.js';

document.addEventListener('scroll', fixNav);

document.addEventListener("DOMContentLoaded", function () {
    //lineGrover()
        if (window.innerWidth >= 1200) 
            window.animate = AmazingScroll({
                start: {
                    visibleAfterLoading: true,
                    waitForScroll: {
                        on: false,
                        ratio:0,
                    }
                },
                animation: {
                    "fade-left": "opacity: 0->1; left:-500px->0; transition:all 0s->all 1s",
                    "fade-left-2": "opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.2s",
                    "fade-left-4": "opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.4s",
                    "fade-left-6": "opacity: 0->1; left:-500px->0; transition:all 0s->all 1s 0.6s",

                    "fade-right": "opacity: 0->1; right:-500px->0; transition:all 0s->all 1s",
                    "fade-right-2": "opacity: 0->1; right:-500px->0; transition:all 0s->all 1s 0.2s",
                    "fade-right-4": "opacity: 0->1; right:-500px->0; transition:all 0s->all 1s 0.4s",
                    "fade-right-6": "opacity: 0->1; right:-500px->0; transition:all 0s->all 1s 0.6s",

                    "fade-left-top": "opacity: 0->1; left:-50px->0; top:-50px->0; transition:alls 0s->all 1s",
                    "fade-left-bottom": "opacity: 0->1; left:-50px->0; bottom:-50px->0; transition:all 0s->all 1s",

                    "opacity": "transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s",
                    "opacity-2": "transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s 0.2s",
                    "opacity-4": "transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s 0.4s",
                    "opacity-6": "transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s 0.6s",

                    "rotate": "transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s",
                    "rotate-2": "transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s 0.2s",
                    "rotate-4": "transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s 0.4s",
                    "rotate-6": "transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s 0.6s",
                    
                    "fade-top": "top:-100px->0; transition:all 0s->all 1s; opacity:0->1;",
                    "fade-top-0": "top:-100px->0; transition:all 0s->all 1s; opacity:0->1;",
                    "fade-top-2": "top:-100px->0; transition:all 0s->all 1s 0.2s; opacity:0->1;",
                    "fade-top-4": "top:-100px->0; transition:all 0s->all 1s 0.4s; opacity:0->1;",
                    "fade-top-6": "top:-100px->0; transition:all 0s->all 1s 0.6s; opacity:0->1;",
                }
        });
        /* BLOCKING LINKS */
        // var links = [...document.querySelectorAll('a')];
        // links.forEach(link => {
        //     link.href = '#!';
        // });
});


/* WORKING STICKY FOR NAVBAR */
(function($) {
    if((document.body.classList.contains('home')) || (document.body.classList.contains('homepage'))){
        var headingHeight = document.querySelector('.navbar').getClientRects()[0].height;
        var offsetTop = 0;
        offsetTop = 0;
        var scrollLink = $('.btn-down');
            scrollLink.click(function(e) {
                e.preventDefault();
                if (window.innerWidth>=1200)
                    offsetTop = document.querySelector('#nav-main').offsetHeight;
                else
                    offsetTop = 0;
                $('body,html').animate({
                    scrollTop: window.pageYOffset + document.querySelector('#contact-us').getClientRects()[0].top - offsetTop
                }, 1000 );
            });
	 }
})(jQuery)

$('#slider-123').carousel({
    pause: "false"
});


// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/script.js